import React, { useState, useEffect, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../App.css"; // Import global styles
import MainBackground from "../../images/MainBackground.jpg"; // Background image for landscape mode
import MainPotraitBackground from "../../images/MainPotraitBackground.jpg"; // Background image for portrait mode
import CommunityDiscussion from "../../react-frontend/sections/CommunityDiscussion"; // Import Community Discussion
import MyStats from "../../react-frontend/sections/MyStates"; // Import My Stats
import FederalBills from "../../react-frontend/sections/FederalBills"; // Import Federal Bills
import StateBills from "../../react-frontend/sections/StateBills"; // Import State Bills
import ProjectList from "../../react-frontend/sections/ProjectList"; // Import Project List
import LocalProject from "../../react-frontend/sections/LocalProject"; // Import Local Project
import TutorialList from "../../react-frontend/sections/TutorialList"; // ✅ FIX: Import Tutorial Videos
import CharitiesList from "../../react-frontend/sections/CharitiesList"; // Import Charities List
import { useLocation } from "react-router-dom";
import PoliticiansList from "../../react-frontend/sections/PoliticiansList"; // Add this import
import Politician from "../../react-frontend/sections/Politician"; // Add this import
import { FaAngleRight, FaAngleLeft } from "react-icons/fa";
import Quiz from "../components/Quiz"; // Import Quiz component
import { UserContext } from "../context/UserContext"; // Import UserContext
import { 
  FaFileAlt, // Federal Bills
  FaFileContract, // State Bills
  FaComments, // Community Discussion
  FaTrophy, // Leaderboard
  FaProjectDiagram, // Local Project
  FaHandHoldingHeart, // Charities
  FaUserTie, // Politicians
  FaVideo // Tutorial Videos
} from "react-icons/fa";

// Update the tabLabelStyle constant
const tabLabelStyle = {
  position: 'fixed',
  bottom: '520px', // Changed from 70px to 120px to move it higher
  left: '50%',
  transform: 'translateX(-50%)',
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  color: 'white',
  padding: '8px 16px',
  borderRadius: '20px',
  fontSize: '14px',
  zIndex: 1000,
  transition: 'opacity 0.3s ease',
  pointerEvents: 'none',
  textAlign: 'center', // Added to ensure text is centered
  minWidth: '120px' // Added to ensure consistent width for labels
};

// Add this style for side panel labels (add near the existing tabLabelStyle)
const sidePanelLabelStyle = {
  position: 'fixed',
  right: '50px', // Position to the left of the side panel
  backgroundColor: 'rgba(0, 0, 0, 0.8)',
  color: 'white',
  padding: '8px 16px',
  borderRadius: '20px',
  fontSize: '14px',
  zIndex: 1000,
  transition: 'opacity 0.3s ease',
  pointerEvents: 'none',
  textAlign: 'center',
  minWidth: '120px'
};

const Main = () => {
  const location = useLocation();
  const userType = location.state?.userType;
  const initialSelectedButton = location.state?.selectedButton;
  const { quizFinished } = useContext(UserContext);
  const [showQuiz, setShowQuiz] = useState(false);

  // Add selectedButton state
  const [selectedButton, setSelectedButton] = useState(initialSelectedButton);
  
  // Update Quiz visibility logic
  useEffect(() => {
    // Only show quiz if user is logged in and quiz is not finished
    const isAutoLogin = localStorage.getItem('token') && localStorage.getItem('emailId');
    if (!quizFinished && isAutoLogin) {
      setShowQuiz(true);
    } else {
      setShowQuiz(false);
    }
  }, [quizFinished]); // Only depend on quizFinished state

  // Add console.log to debug received state
  console.log('Received state in Main:', { userType, selectedButton });

  // Add state for selection type
  const [currentSelectionType, setCurrentSelectionType] = useState(
    localStorage.getItem("selectionType")
  );

  // Add effect to listen for localStorage changes
  useEffect(() => {
    const checkSelectionType = () => {
      const storedSelectionType = localStorage.getItem("selectionType");
      if (storedSelectionType !== currentSelectionType) {
        setCurrentSelectionType(storedSelectionType);
        // Force re-render of the appropriate component
        if (storedSelectionType === "politician") {
          setLeftTab("Local Project");
        } else if (storedSelectionType === "charity") {
          setLeftTab("Charity");
        } else {
          setLeftTab("Local Project");
        }
      }
    };

    const interval = setInterval(checkSelectionType, 100);
    return () => clearInterval(interval);
  }, [currentSelectionType]);

  const categories = [
    "Affordable housing",
    "Better business conditions",
    "Better education",
    "Crime reduction & law enforcement",
    "Defence and security",
    "Economic stability",
    "Fair workplaces",
    "Family and children's needs",
    "Health and hospitals",
    "Honest government",
    "Increasing migration",
    "Lower taxes for families",
    "Rural needs",
    "Reducing unemployment",
    "Reducing migration",
    "Support for elderly",
    "Tackling climate change",
  ];

  const [selectedCategory, setSelectedCategory] = useState("");
  const [activeTab, setActiveTab] = useState("Existing Project");
  const [leftTab, setLeftTab] = useState("Local Project"); // Default tab set to "Local Project"
  const [activeInnerTab, setActiveInnerTab] = useState("Summary"); // Default to Summary
  const [isLaptop, setIsLaptop] = useState(window.innerWidth > 926);
  const [isLandscape, setIsLandscape] = useState(window.innerWidth > window.innerHeight);
  const [currentPage, setCurrentPage] = useState("Main"); // Tracks the active page
  const [selectedBillTitle, setSelectedBillTitle] = useState(""); // Shared state for selected bill title
  const [blackBoxHeight, setBlackBoxHeight] = useState(window.innerHeight - 5); // Height for black box
  const [hasVisitedLandscape, setHasVisitedLandscape] = useState(false);
  const [rightTab, setRightTab] = useState("Local Projects"); // ✅ Default to "Local Projects"
  const [projectType, setProjectType] = useState("project"); // Add new state for project type

  // Add isSidePanelOpen state
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

  // In the Main component, add this state
  const [activeLabel, setActiveLabel] = useState('');
  const [showLabel, setShowLabel] = useState(false);

  // Add these states in the Main component
  const [sidePanelLabel, setSidePanelLabel] = useState('');
  const [showSidePanelLabel, setShowSidePanelLabel] = useState(false);
  const [sidePanelLabelPosition, setSidePanelLabelPosition] = useState(0);

  // Add this function to handle tab clicks and show labels
  const handleTabWithLabel = (tabName, action) => {
    // Show the label
    setActiveLabel(tabName);
    setShowLabel(true);
    
    // Perform the original action
    action();
    
    // Hide the label after 2 seconds
    setTimeout(() => {
      setShowLabel(false);
    }, 2000);
  };

  const handleCategoryChange = (event) => {
    setSelectedCategory(event.target.value);
  };

  const handleResize = () => {
    const isNowLandscape = window.innerWidth > window.innerHeight;
    setIsLaptop(window.innerWidth > 926);
    setIsLandscape(window.innerWidth > window.innerHeight); // Update orientation
    setBlackBoxHeight(window.innerHeight - 5); // Update black box height
     // If the user rotates to landscape mode, set `hasVisitedLandscape` to true
     if (isNowLandscape) {
      setHasVisitedLandscape(true);
    }
  };

  const navigateToPage = (page) => {
    setCurrentPage(page); // Updates the active page
  };

  const handleProjectClick = async (type) => {  // Modified to accept type parameter
    try {
      // Fetch the list based on type
      const response = await fetch(`/api/projectlist?type=${type}`);
      if (response.ok) {
        const items = await response.json();
        if (items && items.length > 0) {
          // Set the first item as selected
          localStorage.setItem("selectedProjectId", items[0].project_id);
          localStorage.setItem("selectionType", type);
          setCurrentSelectionType(type);
          
          // Update tabs based on type
          if (type === "charity") {
            setLeftTab("Charity");
            setRightTab("Charities");
          } else {
            setLeftTab("Local Project");
            setRightTab("Local Projects");
          }
        }
      }
    } catch (error) {
      console.error(`Error fetching ${type} list:`, error);
    }
  };

  const handlePoliticianClick = (type) => {
    if (type === "politician") {
      localStorage.setItem("selectionType", "politician");
      setCurrentSelectionType("politician"); // Update the state immediately
      setLeftTab("Local Project");
    }
  };

  useEffect(() => {
    // Attach resize and orientation change listener
    window.addEventListener("resize", handleResize);
    return () => {
      // Cleanup on component unmount
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    // Initialize based on user type
    if (userType === 'voter') {
      setSelectedButton('voters');
      setLeftTab("Local Project");
      setRightTab("Local Projects");
    } else if (userType === 'politician') {
      setSelectedButton('politicians');
      setLeftTab("Federal Bills");
      setRightTab("Local Projects");
    }
  }, [userType]);

  // Add this function to handle side panel tab clicks
  const handleSidePanelTabWithLabel = (tabName, action, buttonPosition) => {
    setSidePanelLabel(tabName);
    setSidePanelLabelPosition(buttonPosition);
    setShowSidePanelLabel(true);
    
    // Perform the original action
    action();
    
    // Hide the label after 2 seconds
    setTimeout(() => {
      setShowSidePanelLabel(false);
    }, 2000);
  };

  // Render phone layout for both portrait and landscape when width <= 926
  if (window.innerWidth <= 926) {
    return (
      <div
        style={{
          height: "100vh",
          overflowY: "auto",
          backgroundImage: `url(${MainPotraitBackground})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          paddingTop: "0px",
          paddingBottom: "60px",
          backgroundColor: "#f0f0f0",
        }}
      >
        <div>
          {/* Fixed Tab Buttons Container */}
          <div style={{
            position: 'fixed',
            top: '55px',
            left: '-5px',
            right: 0,
            zIndex: 12,
            padding: '5px',
            paddingTop: '10px'  // Added small top padding
          }}>
            <div className="left-tab-buttons" style={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              WebkitOverflowScrolling: 'touch',
              msOverflowStyle: '-ms-autohiding-scrollbar',
              padding: '5px 0',
              justifyContent: 'space-around'
            }}>
              <button
                className={`left-tab-button ${leftTab === "Federal Bills" ? "active" : ""}`}
                onClick={() => handleTabWithLabel("Federal Bills", () => setLeftTab("Federal Bills"))}
                style={{ padding: '10px' }}
              >
                <FaFileAlt size={20} />
              </button>
              <button
                className={`left-tab-button ${leftTab === "State Bills" ? "active" : ""}`}
                onClick={() => handleTabWithLabel("State Bills", () => setLeftTab("State Bills"))}
                style={{ padding: '10px' }}
              >
                <FaFileContract size={20} />
              </button>
              <button
                className={`left-tab-button ${leftTab === "Community Discussion" ? "active" : ""}`}
                onClick={() => handleTabWithLabel("Community Discussion", () => setLeftTab("Community Discussion"))}
                style={{ padding: '10px' }}
              >
                <FaComments size={20} />
              </button>
              <button
                className={`left-tab-button ${leftTab === "Leaderboard" ? "active" : ""}`}
                onClick={() => handleTabWithLabel("Leaderboard", () => setLeftTab("Leaderboard"))}
                style={{ padding: '10px' }}
              >
                <FaTrophy size={20} />
              </button>
              <button
                className={`left-tab-button ${leftTab === "Local Project" ? "active" : ""}`}
                onClick={() => handleTabWithLabel("Local Project", () => setLeftTab("Local Project"))}
                style={{ padding: '10px' }}
              >
                <FaProjectDiagram size={20} />
              </button>
            </div>
          </div>

          {/* Add the label display */}
          {showLabel && (
            <div style={tabLabelStyle}>
              {activeLabel}
            </div>
          )}

          {/* Content Area */}
          <div
            style={{
              width: window.innerWidth <= 926 ? "95%" : "100%",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              borderRadius: "10px",
              padding: "10px",
              position: "relative",
              marginTop: "110px",
              marginBottom: "60px",
              minHeight: "calc(100vh - 180px)",
              boxSizing: "border-box"
            }}
          >
            {leftTab === "Federal Bills" && <FederalBills />}
            {leftTab === "State Bills" && <StateBills />}
            {leftTab === "Community Discussion" && <CommunityDiscussion />}
            {leftTab === "Leaderboard" && <MyStats />}
            {(leftTab === "Local Project" || leftTab === "Charity") && (
              localStorage.getItem("selectionType") === "politician" ? (
                <Politician />
              ) : (
                <LocalProject key={localStorage.getItem("selectedProjectId")} />
              )
            )}
          </div>

          {/* Side Panel */}
          <div className="side-panel" style={{ 
            position: 'fixed',
            right: 0,
            top: 0,
            width: '240px',
            height: '100vh',
            backgroundColor: 'white',
            boxShadow: '-2px 0 5px rgba(0,0,0,0.2)',
            transform: isSidePanelOpen ? 'translateX(0)' : 'translateX(90%)',
            transition: 'transform 0.3s ease',
            zIndex: 13
          }}>
            {/* Toggle Button */}
            <button 
              className="side-panel-toggle"
              onClick={() => setIsSidePanelOpen(!isSidePanelOpen)}
              style={{
                position: 'absolute',
                left: '-15px',
                top: '50%',
                transform: 'translateY(-50%)',
                width: '40px',
                height: '40px',
                backgroundColor: 'white',
                border: '2px solid #007bff',
                borderRadius: '50%',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 999,
                boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
              }}
            >
              {isSidePanelOpen ? <FaAngleRight size={20} /> : <FaAngleLeft size={20} />}
            </button>

            {/* Fixed Tab Buttons Container for Side Panel */}
            <div style={{
              position: 'fixed',
              top: '55px',
              zIndex: 12,
              padding: '5px',
              paddingTop: '10px',
              width: '240px'
            }}>
              <div className="left-tab-buttons" style={{
                display: 'flex',
                overflowX: 'auto',
                whiteSpace: 'nowrap',
                WebkitOverflowScrolling: 'touch',
                msOverflowStyle: '-ms-autohiding-scrollbar',
                padding: '3px 0'
              }}>
                <button
                  className={`left-tab-button ${rightTab === "Local Projects" ? "active" : ""}`}
                  onClick={(e) => handleSidePanelTabWithLabel(
                    "Local Projects",
                    () => {
                      setRightTab("Local Projects");
                      handleProjectClick("project");
                    },
                    e.target.getBoundingClientRect().top
                  )}
                  style={{ padding: '10px' }}
                >
                  <FaProjectDiagram size={20} />
                </button>
                <button
                  className={`left-tab-button ${rightTab === "Charities" ? "active" : ""}`}
                  onClick={(e) => handleSidePanelTabWithLabel(
                    "Charities",
                    () => {
                      setRightTab("Charities");
                      handleProjectClick("charity");
                    },
                    e.target.getBoundingClientRect().top
                  )}
                  style={{ padding: '10px' }}
                >
                  <FaHandHoldingHeart size={20} />
                </button>
                <button
                  className={`left-tab-button ${rightTab === "Politicians" ? "active" : ""}`}
                  onClick={(e) => handleSidePanelTabWithLabel(
                    "Politicians",
                    () => {
                      setRightTab("Politicians");
                      handlePoliticianClick("politician");
                    },
                    e.target.getBoundingClientRect().top
                  )}
                  style={{ padding: '10px' }}
                >
                  <FaUserTie size={20} />
                </button>
                <button
                  className={`left-tab-button ${rightTab === "Tutorial Videos" ? "active" : ""}`}
                  onClick={(e) => handleSidePanelTabWithLabel(
                    "Tutorials",
                    () => setRightTab("Tutorial Videos"),
                    e.target.getBoundingClientRect().top
                  )}
                  style={{ padding: '10px' }}
                >
                  <FaVideo size={20} />
                </button>
              </div>
            </div>

            {/* Add the side panel label display */}
            {showSidePanelLabel && (
              <div style={{
                ...sidePanelLabelStyle,
                top: sidePanelLabelPosition + 40,
              }}>
                {sidePanelLabel}
              </div>
            )}

            {/* Content Area */}
            <div style={{ 
              marginTop: '100px',
              padding: '10px'
            }}>
              {rightTab === "Local Projects" && <ProjectList onProjectClick={() => handleProjectClick("project")}/>}
              {rightTab === "Charities" && <CharitiesList onCharityClick={() => handleProjectClick("charity")}/>}
              {rightTab === "Politicians" && <PoliticiansList onPoliticianClick={handlePoliticianClick} />}
              {rightTab === "Tutorial Videos" && <TutorialList />}
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div
      className="main-container"
      style={{
        backgroundImage: `url(${MainBackground})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        paddingTop: isLandscape ? "0" : "10px",
      }}
    >
      {showQuiz && <Quiz onClose={() => setShowQuiz(false)} />}
      {currentPage === "Main" ? (
        window.innerWidth <= 926 ? (
          <PhoneLayout
            leftTab={leftTab}
            setLeftTab={setLeftTab}
            rightTab={rightTab}
            setRightTab={setRightTab}
            handleProjectClick={handleProjectClick}
            handlePoliticianClick={handlePoliticianClick}
            blackBoxHeight={blackBoxHeight}
            projectType={projectType}
            handleSidePanelTabWithLabel={handleSidePanelTabWithLabel}
            showSidePanelLabel={showSidePanelLabel}
            sidePanelLabelPosition={sidePanelLabelPosition}
            sidePanelLabel={sidePanelLabel}
            sidePanelLabelStyle={sidePanelLabelStyle}
          />
        ) : (
          //todo: add laptop layout zirui
          <LaptopLayout
            categories={categories}
            selectedCategory={selectedCategory}
            handleCategoryChange={handleCategoryChange}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
            leftTab={leftTab}
            setLeftTab={setLeftTab}
            activeInnerTab={activeInnerTab}
            setActiveInnerTab={setActiveInnerTab}
            navigateToPage={navigateToPage}
            selectedBillTitle={selectedBillTitle}
            setSelectedBillTitle={setSelectedBillTitle}
            handleProjectClick={handleProjectClick}
            handlePoliticianClick={handlePoliticianClick}
            blackBoxHeight={blackBoxHeight}
            rightTab={rightTab}
            setRightTab={setRightTab}
            projectType={projectType}
          />
        )
      ) : currentPage === "CommunityDiscussion" ? (
        <CommunityDiscussion selectedBillTitle={selectedBillTitle} />
      ) : (
        <MyStats />
      )}
    </div>
  );
};

const LaptopLayout = ({
  categories,
  selectedCategory,
  handleCategoryChange,
  activeTab,
  setActiveTab,
  leftTab,
  setLeftTab,
  activeInnerTab,
  setActiveInnerTab,
  navigateToPage,
  handleProjectClick,
  handlePoliticianClick,
  blackBoxHeight,
  rightTab,
  setRightTab,
  projectType,
}) => {
  // Add useEffect to handle initial project/charity/politician selection
  React.useEffect(() => {
    const selectFirstItem = async () => {
      // Check URL parameters first
      const urlParams = new URLSearchParams(window.location.search);
      const sharedProjectId = urlParams.get("projectId") || urlParams.get("selectedProjectId");
      const sharedPoliticianId = urlParams.get("politicianId") || urlParams.get("selectedPoliticianId");
      const urlSelectionType = urlParams.get("selectionType");

      // If URL parameters exist, set them and return
      if ((sharedProjectId || sharedPoliticianId) && urlSelectionType) {
        if (sharedPoliticianId && urlSelectionType === "politician") {
          localStorage.setItem("selectedPoliticianId", sharedPoliticianId);
          localStorage.setItem("selectionType", "politician");
          setLeftTab("Local Project");
          setRightTab("Politicians");
          return;
        } else if (sharedProjectId) {
          localStorage.setItem("selectedProjectId", sharedProjectId);
          localStorage.setItem("selectionType", urlSelectionType);
          setLeftTab(urlSelectionType === "charity" ? "Charity" : "Local Project");
          setRightTab(urlSelectionType === "charity" ? "Charities" : "Local Projects");
          return;
        }
      }

      // Only proceed with automatic selection if no URL parameters exist
      let apiEndpoint;
      let type;

      if (rightTab === "Local Projects") {
        apiEndpoint = "/api/projectlist?type=project";
        type = "project";
      } else if (rightTab === "Charities") {
        apiEndpoint = "/api/projectlist?type=charity";
        type = "charity";
      } else if (rightTab === "Politicians") {
        apiEndpoint = "/api/politicians";
        type = "politician";
      } else {
        return;
      }

      try {
        const response = await fetch(apiEndpoint);
        if (response.ok) {
          const items = await response.json();
          if (items && items.length > 0) {
            if (type === "politician") {
              localStorage.setItem("selectedPoliticianId", items[0].id);
              localStorage.setItem("selectionType", "politician");
              setLeftTab("Local Project");
            } else {
              localStorage.setItem("selectedProjectId", items[0].project_id);
              localStorage.setItem("selectionType", type);
              setLeftTab(type === "charity" ? "Charity" : "Local Project");
            }
          }
        }
      } catch (error) {
        console.error(`Error fetching ${type}:`, error);
      }
    };

    selectFirstItem();
  }, [rightTab, setLeftTab]);

  return (
    <div style={{ display: "flex", width: "100%" }}>
      <div className="main-left-column" style={{ 
        width: "70%",
        flexShrink: 0
      }}>
        <div className="left-tab-buttons">
          <button
            className={`left-tab-button ${leftTab === "Federal Bills" ? "active" : ""}`}
            onClick={() => setLeftTab("Federal Bills")}
          >
            Federal Bills
          </button>
          <button
            className={`left-tab-button ${leftTab === "State Bills" ? "active" : ""}`}
            onClick={() => setLeftTab("State Bills")}
          >
            State Bills
          </button>
          <button
            className={`left-tab-button ${leftTab === "Community Discussion" ? "active" : ""}`}
            onClick={() => setLeftTab("Community Discussion")}
          >
            Community Discussion
          </button>
          <button
            className={`left-tab-button ${leftTab === "Leaderboard" ? "active" : ""}`}
            onClick={() => setLeftTab("Leaderboard")}
          >
            Leaderboard
          </button>
          <button
            className={`left-tab-button ${leftTab === "Local Project" || leftTab === "Charity" ? "active" : ""}`}
            onClick={() => {
              if (rightTab === "Charities") {
                setLeftTab("Charity");
              } else if (rightTab === "Politicians") {
                setLeftTab("Local Project");
                localStorage.setItem("selectionType", "politician");
              } else {
                setLeftTab("Local Project");
              }
            }}
          >
            {rightTab === "Politicians" 
              ? "Politician"
              : rightTab === "Charities" 
                ? "Charity" 
                : "Local Project"}
          </button>
        </div>
        {leftTab && (
          <div
            className="left-tab-content"
            style={{
              height: `${blackBoxHeight}px`, // Set dynamic height for the entire box
              padding: "5px", // Padding at the bottom
              boxSizing: "border-box", // Ensure padding is included in the total height
              overflow: "hidden", // Ensure no overflow
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div
              className="tab-content-box"
              style={{
                wordWrap: "break-word", // Ensures text wraps properly
                overflowWrap: "break-word", // Fallback for long words
                height: "93%", // Adjust height dynamically
              }}
            >
              {leftTab === "Federal Bills" && <FederalBills />}
              {leftTab === "State Bills" && <StateBills />}
              {leftTab === "Community Discussion" && <CommunityDiscussion />}
              {leftTab === "Leaderboard" && <MyStats />}
              {leftTab === "Local Project" && (
                localStorage.getItem("selectionType") === "politician" ? (
                  <Politician />
                ) : (
                  <LocalProject />
                )
              )}
              {leftTab === "Charity" && <LocalProject />}
            </div>
          </div>
        )}
      </div>
      <div className="main-right-column" style={{ 
        position: "relative",
        width: "30%",
        flexShrink: 0,
        overflow: "hidden"
      }}>
        <div className="right-tab-buttons" style={{
          position: "relative",
          top: 0,
          zIndex: 999 // To keep buttons above content
        }}>
          <button 
            className={`right-tab-button ${rightTab === "Local Projects" ? "active" : ""}`} 
            onClick={() => {
              setRightTab("Local Projects");
              handleProjectClick("project");
            }}
          >
            Local Projects
          </button>
          <button 
            className={`right-tab-button ${rightTab === "Charities" ? "active" : ""}`} 
            onClick={() => {
              setRightTab("Charities");
              handleProjectClick("charity");
            }}
          >
            Charities
          </button>
          <button 
            className={`right-tab-button ${rightTab === "Politicians" ? "active" : ""}`} 
            onClick={() => {
              setRightTab("Politicians");
              handlePoliticianClick("politician");
            }}
          >
            Politicians
          </button>
          <button 
            className={`right-tab-button ${rightTab === "Tutorial Videos" ? "active" : ""}`} 
            onClick={() => setRightTab("Tutorial Videos")}
          >
            Tutorials
          </button>
        </div>
        <div>
          {rightTab === "Local Projects" ? (
            <ProjectList 
              onProjectClick={(type) => {
                handleProjectClick(type);
                setLeftTab("Local Project");
              }}
            />
          ) : rightTab === "Charities" ? (
            <CharitiesList 
              onCharityClick={() => {
                handleProjectClick("charity");
                setLeftTab("Charity");
              }}
            />
          ) : rightTab === "Politicians" ? (
            <PoliticiansList 
              onPoliticianClick={() => {
                handlePoliticianClick("politician");
                setLeftTab("Local Project");
                localStorage.setItem("selectionType", "politician");
              }}
            />
          ) : (
            <TutorialList />
          )}
        </div>
      </div>
    </div>
  );
};

const PhoneLayout = ({
  leftTab,
  setLeftTab,
  rightTab,
  setRightTab,
  handleProjectClick,
  handlePoliticianClick,
  blackBoxHeight,
  projectType,
  handleSidePanelTabWithLabel,
  showSidePanelLabel,
  sidePanelLabelPosition,
  sidePanelLabel,
  sidePanelLabelStyle
}) => {
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);
  const [hoveredTab, setHoveredTab] = useState(null);

  // Function to handle charity tab selection
  const handleCharityTabClick = async () => {
    try {
      const response = await fetch("/api/projectlist?type=charity");
      if (response.ok) {
        const charities = await response.json();
        if (charities && charities.length > 0) {
          localStorage.setItem("selectedProjectId", charities[0].project_id);
          localStorage.setItem("selectionType", "charity");
          setLeftTab("Charity");
          handleProjectClick("charity");
          setIsSidePanelOpen(false);
        }
      }
    } catch (error) {
      console.error("Error fetching charities:", error);
    }
  };

  // Helper function for tooltip component
  const TabWithTooltip = ({ name, icon, isActive }) => {
    const handleTouch = () => {
      setHoveredTab(name);
      // Hide tooltip after 2 seconds
      setTimeout(() => setHoveredTab(null), 2000);
    };

    return (
      <div style={{ position: 'relative' }}>
        <button
          className={`left-tab-button ${isActive ? "active" : ""}`}
          onClick={() => setLeftTab(name)}
          onMouseEnter={() => setHoveredTab(name)}
          onMouseLeave={() => setHoveredTab(null)}
          onTouchStart={handleTouch}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            padding: "12px",
            backgroundColor: isActive ? "#007bff" : "#f4f4f4",
            color: isActive ? "#fff" : "#000",
            borderRadius: "8px",
            cursor: "pointer",
            border: "1px solid #ccc",
            fontSize: "20px",
            minWidth: "40px",
            WebkitTapHighlightColor: "transparent" // Remove tap highlight on mobile
          }}
        >
          {icon}
        </button>
        {hoveredTab === name && (
          <div style={{
            position: "absolute",
            bottom: "-30px", // Increased distance from button
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            color: "white",
            padding: "6px 12px", // Increased padding
            borderRadius: "4px",
            fontSize: "14px", // Increased font size
            whiteSpace: "nowrap",
            zIndex: 1000,
            animation: 'fadeInOut 2s ease'
          }}>
            {name}
          </div>
        )}
      </div>
    );
  };

  return (
    <div style={{ 
      width: '100%', 
      height: '100%', 
      position: 'relative',
      boxSizing: 'border-box'
    }}>
      {/* Main Content */}
      <div style={{ 
        width: '100%',
        height: '100%',
        transition: 'all 0.3s ease',
        marginTop: '50px',
      }}>
        {/* Left Tab Buttons */}
        <div className="left-tab-buttons" style={{
          padding: '10px',
          borderRadius: '5px',
          marginBottom: '10px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '15px'
        }}>
          <TabWithTooltip 
            name="Federal Bills"
            icon={<FaFileAlt size={20} />}
            isActive={leftTab === "Federal Bills"}
          />
          <TabWithTooltip 
            name="State Bills"
            icon={<FaFileContract size={20} />}
            isActive={leftTab === "State Bills"}
          />
          <TabWithTooltip 
            name="Community Discussion"
            icon={<FaComments size={20} />}
            isActive={leftTab === "Community Discussion"}
          />
          <TabWithTooltip 
            name="Leaderboard"
            icon={<FaTrophy size={20} />}
            isActive={leftTab === "Leaderboard"}
          />
          <TabWithTooltip 
            name={localStorage.getItem("selectionType") === "politician" 
              ? "Politician" 
              : projectType === "charity" 
                ? "Charity" 
                : "Local Project"}
            icon={localStorage.getItem("selectionType") === "politician"
              ? <FaUserTie size={20} />
              : projectType === "charity"
                ? <FaHandHoldingHeart size={20} />
                : <FaProjectDiagram size={20} />}
            isActive={leftTab === "Local Project" || leftTab === "Charity"}
          />
        </div>

        {/* Side Panel */}
        <div className="side-panel" style={{
          position: 'fixed',
          right: isSidePanelOpen ? '0' : '-240px',
          top: '45px',
          bottom: '35px',
          width: '270px',
          backgroundColor: 'white',
          boxShadow: '-2px 0 5px rgba(0,0,0,0.2)',
          transition: 'right 0.3s ease',
          zIndex: 10,
          display: 'flex',
          flexDirection: 'column',
          overflowY: 'auto'
        }}>
          {/* Fixed Tab Buttons Container for Side Panel */}
          <div style={{
            position: 'fixed',
            top: '55px',
            zIndex: 12,
            padding: '5px',
            paddingTop: '10px',
            width: '240px'
          }}>
            <div className="left-tab-buttons" style={{
              display: 'flex',
              overflowX: 'auto',
              whiteSpace: 'nowrap',
              WebkitOverflowScrolling: 'touch',
              msOverflowStyle: '-ms-autohiding-scrollbar',
              padding: '3px 0'
            }}>
              <button
                className={`left-tab-button ${rightTab === "Charities" ? "active" : ""}`}
                onClick={handleCharityTabClick}
                style={{ padding: '10px' }}
              >
                <FaHandHoldingHeart size={20} />
              </button>
              <button
                className={`left-tab-button ${rightTab === "Local Projects" ? "active" : ""}`}
                onClick={(e) => handleSidePanelTabWithLabel(
                  "Local Projects",
                  () => {
                    setRightTab("Local Projects");
                    handleProjectClick("project");
                  },
                  e.target.getBoundingClientRect().top
                )}
                style={{ padding: '10px' }}
              >
                <FaProjectDiagram size={20} />
              </button>
              <button
                className={`left-tab-button ${rightTab === "Politicians" ? "active" : ""}`}
                onClick={(e) => handleSidePanelTabWithLabel(
                  "Politicians",
                  () => {
                    setRightTab("Politicians");
                    handlePoliticianClick("politician");
                  },
                  e.target.getBoundingClientRect().top
                )}
                style={{ padding: '10px' }}
              >
                <FaUserTie size={20} />
              </button>
              <button
                className={`left-tab-button ${rightTab === "Tutorial Videos" ? "active" : ""}`}
                onClick={(e) => handleSidePanelTabWithLabel(
                  "Tutorials",
                  () => setRightTab("Tutorial Videos"),
                  e.target.getBoundingClientRect().top
                )}
                style={{ padding: '10px' }}
              >
                <FaVideo size={20} />
              </button>
            </div>
          </div>

          {/* Add the side panel label display */}
          {showSidePanelLabel && (
            <div style={{
              ...sidePanelLabelStyle,
              top: sidePanelLabelPosition + 40,
            }}>
              {sidePanelLabel}
            </div>
          )}

          {/* Panel Content */}
          <div style={{ marginTop: '15px' }}>
            {rightTab === "Local Projects" && (
              <ProjectList 
                onProjectClick={() => {
                  handleProjectClick("project");
                  setLeftTab("Local Project");
                  setIsSidePanelOpen(false);
                }}
              />
            )}
            {rightTab === "Charities" && (
              <CharitiesList 
                onCharityClick={() => {
                  handleProjectClick("charity");
                  setLeftTab("Charity");
                  setIsSidePanelOpen(false);
                }}
              />
            )}
            {rightTab === "Politicians" && (
              <PoliticiansList 
                onPoliticianClick={() => {
                  handlePoliticianClick("politician");
                  setLeftTab("Local Project");
                  localStorage.setItem("selectionType", "politician");
                  setIsSidePanelOpen(false);
                }}
              />
            )}
            {rightTab === "Tutorial Videos" && <TutorialList />}
          </div>
        </div>

        {/* Content Area */}
        <div style={{
          width: window.innerWidth <= 926 ? "95%" : "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          borderRadius: "10px",
          padding: "10px",
          position: "relative",
          marginTop: "110px",
          marginBottom: "60px",
          minHeight: "calc(100vh - 180px)",
          boxSizing: "border-box"
        }}>
          {leftTab === "Federal Bills" && <FederalBills />}
          {leftTab === "State Bills" && <StateBills />}
          {leftTab === "Community Discussion" && <CommunityDiscussion />}
          {leftTab === "Leaderboard" && <MyStats />}
          {(leftTab === "Local Project" || leftTab === "Charity") && (
            localStorage.getItem("selectionType") === "politician" ? (
              <Politician />
            ) : (
              <LocalProject key={localStorage.getItem("selectedProjectId")} />
            )
          )}
        </div>
      </div>
    </div>
  );
};

// Add this CSS to your stylesheet if not already present
const styles = `
  @keyframes fadeInOut {
    0% { opacity: 0; }
    10% { opacity: 1; }
    90% { opacity: 1; }
    100% { opacity: 0; }
  }
`;

// Add the styles to the document
const styleSheet = document.createElement("style");
styleSheet.innerText = styles;
document.head.appendChild(styleSheet);

export default Main;
